import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import AssetsPage from '@/pages/AssetsPage';
import { useAuth } from '@/store/auth';

export default function AdminAssetsRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect admin users to the superior AdminPage functionality
    if (user?.role === 'admin') {
      // Preserve any query parameters like facility selection
      const searchParams = new URLSearchParams(location.search);
      const facility = searchParams.get('facility');
      
      // Redirect to admin page with facility context if available
      const adminPath = facility ? `/admin?facility=${facility}` : '/admin';
      navigate(adminPath, { replace: true });
    }
  }, [user, navigate, location.search]);

  // Only render AssetsPage for facility users
  if (user?.role === 'facility') {
    return <AssetsPage />;
  }

  // For admin users, show loading while redirect happens
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to Admin Dashboard...</p>
      </div>
    </div>
  );
}